/**
 * Several chat elements can be mounted at once (on /chat/ the page chat and the
 * sticky chat), and they share one socket. Only the last one to go may close
 * it: closing it under the other would stop its live messages and statuses
 * until a reload, because socket.io never reconnects after a manual close.
 * Kept free of imports so it can be tested on its own.
 */

let holders = 0

export const acquireSocket = (): void => {
  holders += 1
}

/** Returns true when no chat element uses the socket any more. */
export const releaseSocket = (): boolean => {
  holders = Math.max(0, holders - 1)
  return holders === 0
}

/** Test helper. */
export const _resetSocketHolders = (): void => {
  holders = 0
}
